models.service('WithdrawRequestModel', [
    '$filter', 'constants', 'Utils',
    function ($filter, Const, Utils) {

        function WithdrawRequest(data) {
            var self = this;

            self.confirmDate = parseInt(parseInt(data.confirmDate, 10) * 1000, 10);
            self.requestDate = parseInt(parseInt(data.requestDate, 10) * 1000, 10);
            self.status = Const.withdrawRequestStatusToType[data.status] || '';
            self.amount = data.amount;
            self.currency = data.currency;
            self.method = Const.paymentMethodsToTypes[data.method];
            self.login = data.login;
            self.id = data.id;
            self.transactionId = data.transactionId;

            self.clear = function () {}
        }

        return WithdrawRequest;
    }]);